// useDropdownMultipleNavigation.ts
import type { ComputedRef, Ref } from 'vue'
import { useDropdownNavigation } from '@designSystem/components/wrapper/dropdownContainer/useDropdownNavigation'
import type { LigneAffichage } from './useDropdownMultiple'

export function useDropdownMultipleNavigation<T>(
  lignesAAfficher: ComputedRef<LigneAffichage<T>[]>,
  isOpen: Ref<boolean>,
  onItemClick: (ligne: LigneAffichage<T>) => void,
) {
  const nav = useDropdownNavigation(lignesAAfficher, isOpen)

  const onKeyDown = (event: KeyboardEvent) => {
    switch (event.key) {
      case 'Enter':
      case ' ': {
        event.preventDefault()
        nav.handleSpace()

        if (!isOpen.value) return
        const idx = nav.selectIndex.value
        if (idx < 0) return

        const ligne = lignesAAfficher.value[idx]
        if (ligne) onItemClick(ligne)
        return
      }

      case 'ArrowDown':
        event.preventDefault()
        nav.handleArrowDownKey()
        return

      case 'ArrowUp':
        event.preventDefault()
        nav.handleArrowUpKey()
        return

      case 'Tab':
        nav.handleTab()
        return

      default:
        return
    }
  }

  return {
    ...nav,
    onKeyDown,
  }
}
